// extracted by mini-css-extract-plugin
module.exports = {"Container":"Credits_Container__1zr-T","Options":"Credits_Options__2jbxA","Card":"Credits_Card__2zx3r"};